/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_BodyInputs */

const et_contact_success_body = /** @type {(inputs: Contact_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Võtame teiega ühendust 24 tunni jooksul või varem.`)
};

const en_contact_success_body = /** @type {(inputs: Contact_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll contact you within 24 hours or sooner.`)
};

/**
* | output |
* | --- |
* | "We'll contact you within 24 hours or sooner." |
*
* @param {Contact_Success_BodyInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_body = /** @type {((inputs?: Contact_Success_BodyInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_BodyInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_success_body(inputs)
	return en_contact_success_body(inputs)
});